import { DropdownOptionIntegerId } from '@/models/DropdownOptionIntegerId';

export class TargetObjectFilterData {
    targetObjects: Array<DropdownOptionIntegerId>;
    platforms: Array<DropdownOptionIntegerId>;
    dataSets: Array<DropdownOptionIntegerId>;
    dataOwners: Array<DropdownOptionIntegerId>;
}
